<template lang="pug">
  include ./../../../mixins
  div(@click.prevent='openPopup()')
    slot(name='title')
    slot(name='icon')
    slot(name='content')
</template>

<script>

export default {
  name: 'ModalTrigger',
  props: {
    url: {
      type: String,
      default: () => null,
    },
    name: {
      type: String,
    },
    className: {
      type: String,
      default: 'v--modal',
    },
    srcVideo: {
      type: String,
    },
    titleForm: {
      type: String,
    },
    title: {
      type: String,
    },
    description: {
      type: String,
    },
  },
  methods: {
    openPopup() {
      this.$modal.show(this.modalTable,
        {
          title: this.title,
          description: this.description,
          titleForm: this.titleForm,
        }, {
          name: this.name,
          width: '100%',
          height: 'auto',
          adaptive: true,
          scrollable: true,
          classes: this.className,
        })
    },
  },
  computed: {
    modalTable() {
      const components = {
        'components/app/Modals/PhoneModal': () => import('src/components/app/Modals/PhoneModal.vue'),
      };
      return components[this.url];
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/js/components/app/UiElements/ModalTrigger.vue